package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.ui.graphics.ImageBitmap
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.khronos.webgl.Int8Array
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLCanvasElement
import kotlin.js.Promise

private const val RENDER_SCALE = 2

// pdf.js is loaded by a script tag in index.html.
actual suspend fun renderPdfPages(pdf: ByteArray): List<ImageBitmap> {
    val pdfjs = window.asDynamic().pdfjsLib
    // pdf.js takes ownership of the buffer it's given, so hand it a copy.
    val data = Uint8Array(Int8Array(pdf.unsafeCast<Int8Array>()).buffer)
    val options = js("{}")
    options.data = data
    val pdfDocument = (pdfjs.getDocument(options).promise as Promise<dynamic>).await()
    val pageCount = pdfDocument.numPages as Int
    return (1..pageCount).map { number ->
        val page = (pdfDocument.getPage(number) as Promise<dynamic>).await()
        val viewportOptions = js("{}")
        viewportOptions.scale = RENDER_SCALE
        val viewport = page.getViewport(viewportOptions)
        val canvas = document.createElement("canvas") as HTMLCanvasElement
        canvas.width = (viewport.width as Number).toInt()
        canvas.height = (viewport.height as Number).toInt()
        val renderOptions = js("{}")
        renderOptions.canvasContext = canvas.getContext("2d")
        renderOptions.viewport = viewport
        (page.render(renderOptions).promise as Promise<dynamic>).await()
        val base64 = canvas.toDataURL("image/png").substringAfter(",")
        val binary = window.atob(base64)
        val bytes = ByteArray(binary.length) { binary[it].code.toByte() }
        bytes.toImageBitmap() ?: error("Couldn't decode page $number")
    }
}
